import { Box, SvgIcon, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import React from 'react';
import getMuiIcon from '../../../utils/getMuiIcon';
import { palette } from '../../../assets/styles/themes/tokens';

interface MuLogoProps {
  onClick?: () => void;
  variant?: 'full' | 'small';
  sx?: SystemStyleObject<Theme>;
}

const getLogoContainerStyles = (isFull: boolean, onClick?: () => void): SystemStyleObject<Theme> => ({
  padding: isFull ? '24px 0 24px 24px' : 0,
  cursor: onClick ? 'pointer' : 'default',
  display: 'flex',
  alignItems: 'center',
  justifyContent: isFull ? 'flex-start' : 'center',
});

const MuLogo = ({ onClick, variant = 'full', sx = {} }: MuLogoProps) => {
  const isFull = variant === 'full';
  const logoProps = isFull 
    ? {
      width: '102px',
      height: '16px',
      viewBox: '0 0 128 20',
    }
    : {
      width: '24px',
      height: '24px',
      viewBox: '0 0 32 32',
    };

  return (
    <Box
      data-testid={isFull ? 'logo-button-full' : 'logo-button-small'}
      onClick={onClick}
      aria-label='Home'
      sx={{ ...getLogoContainerStyles(isFull, onClick), ...sx }}
    >
      <SvgIcon
        sx={{ 
          width: logoProps.width, 
          height: logoProps.height,
          color: palette.primary.main 
        }}
        component={getMuiIcon(isFull ? 'muLogoFull' : 'muLogoBag')}
        viewBox={logoProps.viewBox}
      /> 
    </Box>
  );
};

export default MuLogo;
